module.exports = __webpack_public_path__ + "img/brand-02.09246bbd.png";